<template>
    <div class="main-box" :class="{'wide-side-nav':$store.state.theme.wideSideNav}">

        <toolbar/>

        <side-nav/>

        <transition name="slide-fade">
            <nuxt/>
        </transition>

    </div>
</template>

<script>
    import Toolbar from "@/components/template/dash/toolbar";
    import SideNav from "@/components/template/dash/side-nav";
    export default {
        components: {SideNav, Toolbar},
        middleware: 'initializeApp',
        mounted() {

            if(this.$store.getters.isMobile)
                this.$store.dispatch('theme/toggleSideNav')
        }
    }
</script>

<style lang="scss">
    //slide-fade
    .slide-fade-enter-active {
        transition: all .5s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(15px);
        opacity: 0;
    }


</style>
